import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ProjectSetupIResponse } from '@app/models/project-setup.models';

export interface SectionIFormGroup {
  lenderInformation: FormControl<string | null>;
  loanRatesRange: FormControl<string | null>;
  riskDistribution: FormControl<string | null>;
  internalMethodology: FormControl<string | null>;
  confidenceRate: FormControl<string | null>;
  creditPortfolioSelection: FormControl<string | null>;
  capitalGuarantees: FormControl<string | null>;
  defaultStrategy: FormControl<string | null>;
  riskSharing: FormControl<string | null>;
  feesAndCharges: FormControl<string | null>;
}

export function getSectionIFormGroup(
  fb: FormBuilder
): FormGroup<SectionIFormGroup> {
  return fb.nonNullable.group({
    lenderInformation: fb.nonNullable.control<string | null>(null),
    loanRatesRange: fb.nonNullable.control<string | null>(null),
    riskDistribution: fb.nonNullable.control<string | null>(null),
    internalMethodology: fb.nonNullable.control<string | null>(null),
    confidenceRate: fb.nonNullable.control<string | null>(null),
    creditPortfolioSelection: fb.nonNullable.control<string | null>(null),
    capitalGuarantees: fb.nonNullable.control<string | null>(null),
    defaultStrategy: fb.nonNullable.control<string | null>(null),
    riskSharing: fb.nonNullable.control<string | null>(null),
    feesAndCharges: fb.nonNullable.control<string | null>(null),
  });
}

export function getSectionIUpdateData(
  formGroup: FormGroup<SectionIFormGroup>
): ProjectSetupIResponse {
  return {
    crowdfundingServiceProviderDetails:
      formGroup.controls.lenderInformation.value,
    minAndMaxInterestRatesForLoansAvailableToIndividualInvestorPortfolios:
      formGroup.controls.loanRatesRange.value,
    minAndMaxLoanTermsForIndividualInvestorPortfolios:
      formGroup.controls.riskDistribution.value,
    creditRiskCategoriesDistributionDefaultRatesAndWeightedAverageInterestRatesByRiskCategoryAndYear:
      formGroup.controls.internalMethodology.value,
    keyElementsOfInternalMethodologyForCreditRiskAssessmentAndRiskCategoryDeterminationForIndividualCrowdfundingProjects:
      formGroup.controls.confidenceRate.value,
    annualizedTargetRateAndConfidenceIntervalConsideringFeesAndDefaultRates:
      formGroup.controls.creditPortfolioSelection.value,
    proceduresInternalMethodologiesAndCriteriaForSelectingCrowdfundingProjectsForIndividualInvestorPortfolios:
      formGroup.controls.capitalGuarantees.value,
    coverageAndConditionsOfApplicableCapitalGuarantees:
      formGroup.controls.defaultStrategy.value,
    managementOfPortfolioLoansIncludingDefaultByProjectOwner:
      formGroup.controls.riskSharing.value,
    riskSharingStrategies: formGroup.controls.capitalGuarantees.value,
    feesPayableByProjectOwnerOrInvestorIncludingDeductionsFromInterestPayableByProjectOwner:
      formGroup.controls.feesAndCharges.value,
  };
}

export function patchSectionIFormWithProjectSetupIResponse(
  formGroup: FormGroup<SectionIFormGroup>,
  response: ProjectSetupIResponse
): FormGroup<SectionIFormGroup> {
  formGroup.setValue({
    lenderInformation: response.crowdfundingServiceProviderDetails,
    loanRatesRange:
      response.minAndMaxInterestRatesForLoansAvailableToIndividualInvestorPortfolios,
    riskDistribution:
      response.minAndMaxLoanTermsForIndividualInvestorPortfolios,
    internalMethodology:
      response.creditRiskCategoriesDistributionDefaultRatesAndWeightedAverageInterestRatesByRiskCategoryAndYear,
    confidenceRate:
      response.keyElementsOfInternalMethodologyForCreditRiskAssessmentAndRiskCategoryDeterminationForIndividualCrowdfundingProjects,
    creditPortfolioSelection:
      response.annualizedTargetRateAndConfidenceIntervalConsideringFeesAndDefaultRates,
    capitalGuarantees:
      response.proceduresInternalMethodologiesAndCriteriaForSelectingCrowdfundingProjectsForIndividualInvestorPortfolios,
    defaultStrategy:
      response.coverageAndConditionsOfApplicableCapitalGuarantees,
    riskSharing:
      response.managementOfPortfolioLoansIncludingDefaultByProjectOwner,
    feesAndCharges:
      response.feesPayableByProjectOwnerOrInvestorIncludingDeductionsFromInterestPayableByProjectOwner,
  });
  return formGroup;
}
